/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { Button, getPayloadObject, getTelemetryAttributes, ITelemetryContent, TelemetryConstant } from '@msdyn365-commerce-modules/utilities';
import { observer } from 'mobx-react';
import * as React from 'react';

import { IHeaderResources } from '../header.props.autogenerated';

export interface INavIconProps {
    resources: IHeaderResources;
    isExpanded: boolean;
    targetId: string;
    telemetryContent?: ITelemetryContent;
    toggleNavBar(): void;
}

/**
 *
 * NavIcon component.
 * @extends {React.PureComponent<INavIconProps>}
 */

@observer
export class NavIcon extends React.PureComponent<INavIconProps> {

    private readonly attributes?: Msdyn365.IDictionary<string>;

    constructor(props: INavIconProps) {
        super(props);
        const payLoad = getPayloadObject('click', props.telemetryContent!, TelemetryConstant.NavIcon);
        this.attributes = getTelemetryAttributes(props.telemetryContent!, payLoad);
    }

    public render(): JSX.Element {
        return (
            <Button
                className='ms-header__nav-icon'
                onClick={this.props.toggleNavBar}
                title={this.props.resources.mobileHamburgerAriaLabel}
                aria-label={this.props.resources.mobileHamburgerAriaLabel}
                aria-expanded={this.props.isExpanded}
                aria-controls={this.props.targetId}
                {...this.attributes}
            />
        );
    }
}
